import React, { FC } from 'react';
import { IWizardProps } from 'types/wizard';
import WizardPhasePage from './WizardPhasePage';

const Wizard: FC<IWizardProps> = (props) => <WizardPhasePage {...props} />;

export default Wizard;
